import { render } from "./FileItems.vue?vue&type=template&id=0be303ca&scoped=true"
import script from "./FileItems.vue?vue&type=script&lang=js"
export * from "./FileItems.vue?vue&type=script&lang=js"

import "./FileItems.vue?vue&type=style&index=0&id=0be303ca&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be303ca"]])

export default __exports__